import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {currentUserStore} from '../../../../../api/user';

export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, program} = contexts;

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:edition_created.title')
       * t('notifications:edition_signed.title')
       */
      i18n.t(`notifications:${event.type}.title`, {
        actorName:
          actor?._id !== currentUserStore.user?._id
            ? actor?.name
            : i18n.t('shared:label.you'),
        programTitle: program?.title,
      }),
  };
};
